import React from "react";
import api from "~/services/api";
import Label from "~/componentes/CustomForm/Label";
import Select from "~/componentes/CustomForm/Select";
import Input from "~/componentes/CustomForm/Input";

import ShowConfirmacao from "~/utils/ShowConfirmacao";
import { Container } from "./styles";
import CustomScrollBar from "~/componentes/CustomScrollBar";
import { Materialize } from "~/styles/materializeGrid";
import { SLModalFooter } from "~/pages/Sistema/componentes/SistemaList";

function EditContent({ estados, mountedData }) {
  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    ShowConfirmacao(
      async () => {
        let response;

        response = await api.put("/signed/empresa/administracao/organizacao/unidade", {
          ...data,
          id: mountedData.id,
        });

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao editar essa Unidade, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja editar essa Unidade?`,
        successModal: `Unidade atualizada com sucesso!`,
      }
    );
  }

  return (
    <Container onSubmit={handleSubmit}>
      <CustomScrollBar fixScrollMargin autoHeightMin="62vh" autoHeightMax="62vh">
        <Materialize className="padding-form">
          <div className="row">
            <Label title="Nome *" className="col s8 m8 l8">
              <Input name="nome" defaultValue={mountedData?.nome} />
            </Label>
            <Label title="Estado *" className="col s4 m4 l4">
              <Select
                isNumber
                list={{ list: estados, value: "id", label: "nome" }}
                defaultValue={mountedData?.idEstado}
                name="idEstado"
                firstOption
              />
            </Label>
          </div>
        </Materialize>
      </CustomScrollBar>
      <SLModalFooter />
    </Container>
  );
}

export default EditContent;
